var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"no-data text-center m-auto"},[(_vm.type === 'question')?_c('img',{staticClass:"icon",attrs:{"src":require("mlearn/icons/no-question.svg"),"alt":"no data"}}):_c('img',{staticClass:"icon",attrs:{"src":require("mlearn/icons/no-data.svg"),"alt":"no data"}}),_vm._v(" "),_c('div',{staticClass:"text"},[_vm._v(_vm._s(_vm.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }